module.exports = __webpack_public_path__ + "img/archery_tower_small.15f9c26c.png";